export default "__VITE_ASSET__BmxxGa$Q__"